module.exports = __webpack_public_path__ + "static/media/play_green.7de44d02.png";